import { Alert, AlertTitle, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';
import { IssueVariant } from '~/common/types/Issue';

export interface IssueAlertProps {
  loading?: boolean;
  variant: IssueVariant;
  onActionClick?: () => void;
}

export const IssueAlert = ({ variant, onActionClick }: IssueAlertProps) => {
  const { t } = useTranslation(I18nNamespace.common, { keyPrefix: `IssueAlert.${variant}` });

  return (
    <Alert
      severity="error"
      color="error"
      action={
        onActionClick ? (
          <Button variant="outlined" color="inherit" onClick={() => onActionClick()} sx={{ alignSelf: 'center' }}>
            {t('action')}
          </Button>
        ) : null
      }
    >
      <AlertTitle>{t('title')}</AlertTitle>
      {t('description')}
    </Alert>
  );
};
